import {HttpStatusCode} from '@angular/common/http';

export interface TokenResponse {
  readonly token_text?: string;
  readonly status: HttpStatusCode;
}
